import { render } from "./AppInformation.vue?vue&type=template&id=f5a6586a&scoped=true"
import script from "./AppInformation.vue?vue&type=script&lang=js"
export * from "./AppInformation.vue?vue&type=script&lang=js"

import "./AppInformation.vue?vue&type=style&index=0&id=f5a6586a&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5a6586a"]])

export default __exports__